import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { authSession } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/");
      return;
    }

    authSession(sessionId)
      .then((u) => {
        setUser(u);
        // Clear the session_id fragment from the URL
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/");
      })
      .catch(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/");
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-muted-foreground">A iniciar sessão...</p>
    </div>
  );
}
